export const saveConsentFormUrl = (serviceId) =>
  `/External/update-clinical-service-from-consent?clinicalServiceId=${serviceId}`;
export const getConsentDataUrl = (searchType, keyword) =>
  `/External/get-consent?searchType=${searchType}&keyword=${keyword}`;
export const savePharmacyFirstConsent = () =>
  "/External/save-pharmacy-first-data";
export const saveRatingUrl = () => "/External/save-rating";
export const GetPharmacyBookingByIdUrl = (pharmacyId, serviceID) =>
  `/PrivateServicesBooking/get-booking-by-pharmacy-id?pharmacyID=${pharmacyId}&serviceID=${serviceID}`;
export const savePharmacyBookingUrl = () =>
  "/PrivateServicesBooking/save-pharmacy-booking";
export const saveServiceDataUrl = () =>
  "/PrivateServicesBooking/save-service-data";
export const GetPrivateServicesByPharmacyIdUrl = (pharmacyId) =>
  `/PrivateServicesBooking/get-pharmacy-default-services-by-pharmacy-id?pharmacyID=${pharmacyId}`;
export const getPharmacyNameByClinicalServiceIdUrl = (clinicalserviceId) =>
  `/External/get-pharmacy-name?clinicalserviceId=${clinicalserviceId}`;
export const authenticatePatientUrl = (clinicalserviceId) =>
  `/PrivateServicesBooking/authenticate-reschedule-patient?clinicalserviceId=${clinicalserviceId}`;
export const rescheduleServiceUrl = () =>
  `/PrivateServicesBooking/reschedule-service`;
export const getTemplateByServiceIdUrl = (
  pharmacyId,
  serviceId,
  clinicalServiceId
) =>
  `/PrivateServicesBooking/get-template-by-id?pharmacyId=${pharmacyId}&serviceId=${serviceId}&clinicalServiceId=${clinicalServiceId}`;
export const saveTemplateUrl = () => `/PrivateServicesBooking/save-template`;
export const cancelAppointmentUrl = (clinicalServiceId) =>
  `/PrivateServicesBooking/cancel-appointment?clinicalServiceId=${clinicalServiceId}`;
export const getPharmacyServiceSettingsUrl = (pharmacyId, serviceID) =>
  `/PrivateServicesBooking/get-service-settings?pharmacyID=${pharmacyId}&serviceID=${serviceID}`;
export const getPrescriptionUrl = (clinicalserviceId) =>
  `/PrivateServicesBooking/get-prescription?clinicalserviceId=${clinicalserviceId}`;
export const updatePrescriptionUrl = () =>
  `/PrivateServicesBooking/update-prescription`;
export const getCompanyDetailsUrl = (companyID, serviceID) =>
  `/PrivateServicesBooking/get-company-details?companyID=${companyID}&serviceID=${serviceID}`;
export const getPharmacyServiceAvailibilityUrl = (pharmacyId, serviceID) =>
  `/PrivateServicesBooking/get-pharmacy-availabity?pharmacyID=${pharmacyId}&serviceID=${serviceID}`;
export const getServiceBookingSlotsUrl = (pharmacyId, serviceId, date) =>
  `/PrivateServicesBooking/get-slots-by-date?pharmacyId=${pharmacyId}&serviceId=${serviceId}&date=${date}`;
export const createSessionUrl = () => `Payments/create-session`;
export const createPaymentAuditUrl = () => `Payments/create-payment-audit`;
export const getAllServicesByCompanyIdUrl = (companyID) =>
  `/PrivateServicesBooking/get-services-by-company?companyID=${companyID}`;
export const getPharmacyByServiceUrl = (companyID, serviceID) =>
  `/PrivateServicesBooking/get-pharmacy-by-service?companyID=${companyID}&serviceID=${serviceID}`;
export const getCompanyMarketAppAccountIdByCompanyId = (companyID) =>
  `/Payments/get-company-market-app-accountid-by-companyid?companyID=${companyID}`;
export const getPatitentConsultationByConsultationIdUrl = (consultationID) =>
  `/PrivateServicesBooking/get-patientconsultation-by-consultationid?consultationID=${consultationID}`;
export const getPaymentViaLinkDetailsUrl = (consultationID) =>
  `/PrivateServicesBooking/get-payment-via-link-details?consultationID=${consultationID}`;
